export default {
  cnCode: "CN编码",
  factorValue: "排放因子",
  unit: "单位",
  coefficient: "工艺系数",
  description: "描述",
  createdAt: "创建时间",
  updatedAt: "更新时间",
  action: "操作",
  error: "错误",
  search: "搜索",
  add: "添加因子",
  edit: "编辑",
  template: "模板",
  csvTemplate: "CSV模板",
  xlsxTemplate: "XLSX模板",
  deleteConfirm: "确定要删除此因子吗？",
  deleteConfirmBatch: "确定要删除这些因子吗？",
  import: "导入因子",
  export: "导出因子",
  close: "关闭",
  reset: "重新导入",
  resetConfirm: "确定要重新导入吗？",
  ok: "确定",
  clearInvalid: "清除无效数据",
  showErrorRows: "显示错误数据",
  hideErrorRows: "隐藏错误数据",
  placeholder: {
    cnCode: "输入CN编码 (例如: '24')",
    factorValue: "输入排放因子",
    coefficient: "输入工艺系数 (0-1)",
    description: "输入描述 (例如: '用于低碳钢生产')",
    unit: "选择单位",
  },
  cnCodeRequired: "请输入CN编码",
  cnCodeMaxLength: "CN编码不得超过20个字符",
  cnCodeFormat: "CN编码只能包含字母、数字和下划线",
  cnCodeExample: "示例: 钢铁CN编码 '24', 排放因子 1.5, 工艺系数 0.8",
  factorValueRequired: "请输入排放因子",
  factorValueMin: "排放因子必须大于0",
  factorValueUnit: "单位为kg CO2e/kg，请将水泥转换为此单位",
  coefficientRequired: "请输入工艺系数",
  coefficientRange: "工艺系数必须在0到1之间",
  descriptionMaxLength: "描述不得超过255个字符",
  fetchError: "获取因子失败",
  addSuccess: "因子添加成功",
  addError: "因子添加失败",
  editSuccess: "因子更新成功",
  editError: "因子更新失败",
  deleteSuccess: "因子删除成功",
  deleteError: "因子删除失败",
  exportSuccess: "导出成功",
  exportError: "因子导出失败",
  uploadFormatError: "仅支持CSV或XLSX文件",
  headerInvalid: "文件表头无效，应为: cn_code,factor_value,coefficient,description",
  headerSkipped: "跳过表头行",
  importLimitExceeded: "导入数据超出限制 (最多{max}行有效数据)",
  noValidData: "无有效因子数据",
  parseError: "文件解析失败",
  importError: "因子导入失败",
  importSuccess: "成功导入{count}个因子",
  clearInvalidSuccess: "已清除{count}行无效数据",
  noInvalidData: "无无效数据可清除",
  uploadText: "点击或将文件拖拽到此区域上传",
  uploadHint: "支持CSV和XLSX格式",
  unitRequired: "请选择单位",
  unitInvalid: "单位无效，仅支持kg CO2e/kg或kg CO2e/吨",
  batchDelete: "批量删除",
  batchDeleteSuccess: "成功删除{count}个因子",
  batchDeleteError: "批量删除因子失败",
};
